import React, { useEffect, useRef, useState } from "react";
import { Footer } from "../../components/common";
import ContactUs from "../../components/common/contact-us/ContactUs";
import {
  AboutUs,
  ApplyNow,
  Calculator,
  FAQ,
  Fundings,
  Award,
  BbbLogo,
  Hero,
  HowWeCompare,
  ImportantPoints,
  Testimonials,
  WhoWeAre,
  SchoolsCarousel,
} from "../../components/home";

const Home = ({
  headerFilename,
  headerTitle,
  headerShort,
  keyPoints,
  ourFundingsTitle,
  ourFundingsBubbles,
  ourFundingsSupportText,
  howWeCompareTitle,
  howWeCompareShort,
  howWeCompareTable,
  calculatorTitle,
  calculatorShort,
  faqTitle,
  faqContent,
  registerTitle,
  registerShort,
  registerFormTitle,
  registerFormSubtitle,
  aboutUsTitle,
  aboutUsFeaturedIn,
  testimonialTitle,
  whoWeAreTitle,
  whoWeAreContent,
  whoWeAreFirstImage,
  whoWeAreSecondImage,
  testimonialsData = [],
}) => {
  const fintechSectionRef = useRef(null);
  const [showFintechEmbed, setShowFintechEmbed] = useState(false);

  useEffect(() => {
    document.body.classList.add("home");
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    return () => {
      document.body.classList.remove("home");
    };
  }, []);

  useEffect(() => {
    const target = fintechSectionRef.current;
    if (!target || showFintechEmbed) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowFintechEmbed(true);
          observer.disconnect();
        }
      },
      { rootMargin: "300px 0px" }
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [showFintechEmbed]);

  return (
    <>
      <main>
        <Hero
          fileName={headerFilename}
          title={headerTitle}
          short={headerShort}
        />
        <ImportantPoints points={keyPoints} />
        <Fundings
          title={ourFundingsTitle}
          bubbles={ourFundingsBubbles}
          supportText={ourFundingsSupportText}
        />
        <SchoolsCarousel
          title="Schools where some of our students are"
        />
        <Award />
        <BbbLogo />
        <AboutUs
          title={aboutUsTitle}
          featuredIn={aboutUsFeaturedIn}
        />
        <section
          ref={fintechSectionRef}
          style={{
            paddingTop: '6rem',
            paddingLeft: '2rem',
            paddingRight: '2rem',
            paddingBottom: '0',
            maxWidth: '940px',
            margin: '0 auto',
          }}
        >
          <div
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '940px',
              margin: '0 auto',
              overflow: 'hidden',
              paddingTop: '56.25%', // 16:9 aspect ratio (1200 x 675)
            }}
          >
            {showFintechEmbed ? (
              <iframe
                src="https://fintech.tv/?p=34385&embed=1"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Fintech TV Video"
                loading="lazy"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: '8px',
                }}
              ></iframe>
            ) : null}
          </div>
        </section>
        {testimonialsData.length > 0 && (
          <Testimonials
            title={testimonialTitle}
            testimonials={testimonialsData}
          />
        )}
        <HowWeCompare
          title={howWeCompareTitle}
          short={howWeCompareShort}
          table={howWeCompareTable}
        />
        <Calculator
          title={calculatorTitle}
          short={calculatorShort}
        />
        <ApplyNow
          title={registerTitle}
          short={registerShort}
          formTitle={registerFormTitle}
          formSubtitle={registerFormSubtitle}
        />
        <FAQ
          title={faqTitle}
          content={faqContent}
        />
        <WhoWeAre
          title={whoWeAreTitle}
          // storyTitle={whoWeAreStoryTitle}
          // storyShort={whoWeAreStoryShort}
          // missionTitle={whoWeAreMissionTitle}
          // missionShort={whoWeAreMissionShort}
          content={whoWeAreContent}
          firstImg={whoWeAreFirstImage}
          secondImg={whoWeAreSecondImage}
        />
        <ContactUs />
      </main>
      <Footer />
      {/* <HomeDecorations /> */}
    </>
  );
};

export default Home;
